import Vue from "vue";

Vue.mixin({
  methods: {
    regexPhone() {
      return /^0[0-9]{3}[\s]{1}[0-9]{3}[\s]{1}[0-9]{3,5}$/;
    },

    replacePhone(data) {
      return data.replace(/(\d{4})(\d{3})(\d{3,5})/, "$1 $2 $3");
    },

    regexEmail() {
      return /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    },

    regexName() {
      return /^[^0-9_!@#$%^&*()\-=+{}[\]\\/\\`~?,"<>|]+$/;
    },

    isExistString(filter, string) {
      return string.indexOf(filter) > -1;
    },

    truncateText(text, stop, clamp) {
      if (typeof text !== "undefined") {
        return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
      } else {
        return "";
      }
    },

    phoneNumber(event) {
      let keyCode = event.keyCode;
      if (
        !(
          (keyCode > 47 && keyCode < 58) ||
          (keyCode > 95 && keyCode < 106) ||
          keyCode == 8 ||
          keyCode == 9 ||
          keyCode == 37 ||
          keyCode == 39
        )
      ) {
        event.preventDefault();
      }
    },

    formatPrice(price, symbol = "đ") {
      if (!isNaN(price) && price > 0 && price < 1000) {
        return price + " " + symbol;
      } else if (!isNaN(price) && price >= 1000) {
        return (
          String(price).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " " + symbol
        );
      }
      return "0 " + symbol;
    },

    convertTimestampToDate(timestamp) {
      let date = new Date(timestamp * 1000);
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      return (
        (day < 10 ? "0" + day : day) +
        "/" +
        (month < 10 ? "0" + month : month) +
        "/" +
        year
      );
    },

    formatTime(time) {
      let minutes = "0" + ~~(time / 60);
      let seconds = "0" + (time - minutes * 60);
      return minutes.toString().slice(-2) + "." + seconds.toString().slice(-2);
    },

    replaceSpace(string) {
      return string.split(" ").join("");
    },

    async isValidated(scope) {
      let vm = this;
      let isValidated = await vm.$refs[scope].validate();
      return isValidated;
    },
  },
});

Vue.filter("truncate", function (text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
});
